const endpoints = {
  getStateList: 'getStateList',
  getDistrictList: 'getDistrictList',
  createUser: 'createUser',
  organizationRegister: '/organizationregistration',
  organizationRegister2: '/organizationregistration2',
  loginUser: '/login',
  validateToken: '/validateToken',
  logout: 'logout',
  getUserProfile: '/getUserProfile',
  getUserDetail: '/getUserDetail',
  getUserData: 'getUser', 
  getUserCount: '/getUserCount',
  createProfessionCard: '/createProfessionCard',
  switchUserLogin: '/switchUserLogin',
};

export default endpoints;
